export default __webpack_public_path__ + "static/media/YAS0250.34I-29711_-17164_0.cca25e5d.jpg";